module.exports = __webpack_public_path__ + "static/media/az.39527be0.svg";